import edition from '@/api/edition';
import { TYPE_DEVIS } from '@/configuration/devisConf';
import { TYPE_PDF } from '@/configuration/editionConf';
import gestionErreur from '@/services/general/gestionErreur';

export async function editionPdfDevisAchat(devis) {
  try {
    const response = await edition({
      ids: [devis.id],
      extension: TYPE_PDF,
      typeDonnee: TYPE_DEVIS,
      typeEdition: '',
    });
    
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(response.data);
    
    const disposition = response.request.getResponseHeader('Content-Disposition');
    let filename = `devis_achat_${devis.code}.pdf`;
    
    if (disposition) {
      const filenameMatch = disposition.match(/filename\*=UTF-8''(.*?)$/);
      if (filenameMatch && filenameMatch[1]) {
        filename = decodeURI(filenameMatch[1]);
      }
    }
    
    link.download = filename;
    link.click();
    
    window.URL.revokeObjectURL(link.href);
  } catch (error) {
    gestionErreur('Erreur lors de l\'édition du devis d\'achat', error);
    throw error;
  }
}

export async function prepareEmailDevisAchat(devis) {
  try {
    const response = await edition({
      ids: [devis.id],
      extension: TYPE_PDF,
      typeDonnee: TYPE_DEVIS,
      typeEdition: '',
    });
    
    const pdfBlob = response.data;
    const disposition = response.request.getResponseHeader('Content-Disposition');
    let filename = `devis_achat_${devis.code}.pdf`;
    
    if (disposition) {
      const filenameMatch = disposition.match(/filename\*=UTF-8''(.*?)$/);
      if (filenameMatch && filenameMatch[1]) {
        filename = decodeURI(filenameMatch[1]);
      }
    }
    
    const pdfFile = new File([pdfBlob], filename, { type: 'application/pdf' });
    
    let emailFournisseur = '';
    if (devis.intervenants && devis.intervenants.length > 0) {
      const fournisseur = devis.intervenants.find(i => i.donneurOrdre);
      if (fournisseur && fournisseur.tiers && fournisseur.tiers.email) {
        emailFournisseur = fournisseur.tiers.email;
      }
    }
    
    return {
      pdfFile,
      emailFournisseur,
    };
  } catch (error) {
    gestionErreur('Erreur lors de la préparation de l\'email', error);
    throw error;
  }
}

export async function telechargerDevisAchatZip(devisSelectionnes) {
  if (devisSelectionnes.length === 0) {
    throw new Error('Aucun devis sélectionné');
  }

  try {
    const idsDevis = devisSelectionnes.map(d => d.id);

    const response = await edition({
      ids: idsDevis,
      extension: TYPE_PDF,
      typeDonnee: TYPE_DEVIS,
      typeEdition: '',
      parametresAdditionnels: {
        grouperDansUnPdf: 'false'
      }
    });

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(response.data);
    
    const disposition = response.request.getResponseHeader('Content-Disposition');
    let filename = `devis_achat_${new Date().getTime()}.zip`;
    
    if (disposition) {
      const filenameMatch = disposition.match(/filename\*=UTF-8''(.*?)$/);
      if (filenameMatch && filenameMatch[1]) {
        filename = decodeURI(filenameMatch[1]);
      }
    }
    
    link.download = filename;
    link.click();

    window.URL.revokeObjectURL(link.href);
    
    return idsDevis.length;
  } catch (error) {
    gestionErreur('Erreur lors du téléchargement des devis', error);
    throw error;
  }
}